import { getRenewalAdminDomains } from "../http/renewalHttp/RenewalMemberHttp"
import { useCallback, useEffect, useState } from "react"
import { Stack, Pagination } from "@mui/material"
import { createPortal } from "react-dom"
import FormButton from "./FormButton"
import Input from "./Input"
import Div from "./Div"
import Select from "./Select"
import { getAssignedToData, updateAssignedTo,getSpecificMemberTodaysDomainsHttp } from "../http/renewalHttp/RenewalHttp";

export default function DomainListModal({ handleClicked, admin, ...props }) {

    const [domainList, setDomainList] = useState()
    const [initialDomainList, setInitialDomainList] = useState()
    const [start_date, setStartDate] = useState()
    const [end_date, setEndDate] = useState()
    const [assignedToList, setAssignedToList] = useState([]); 
const [selectedAssignedTo, setSelectedAssignedTo] = useState({});

    const [search, setSearch] = useState('')

    // const [sortColumn, setSortColumn] = useState(null);
    // const [sortOrder, setSortOrder] = useState("asc");


    const [currentPage, setCurrentPage] = useState(1);

    const itemsPerPage = 15;

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;

    const currentItems = domainList ? domainList.slice(indexOfFirstItem, indexOfLastItem) : null;

    // Calculate total pages
    const totalPages = domainList ? Math.ceil(domainList.length / itemsPerPage) : null;

    // Change page
    const paginate = (event, value) => {
        setCurrentPage(value);
    };

    const getRenewalAdminDomain = useCallback(async () => {
    let response;
    // Check if we are coming from the 'today' widget
    if (admin.month === 'today') {
        response = await getSpecificMemberTodaysDomainsHttp(admin.admin_email);
    } else {
        response = await getRenewalAdminDomains(admin);
    }

    if (response && response.domains) {
        setDomainList(response.domains);
        setInitialDomainList(response.domains);
    }
}, [admin]);

    const fetchAssignedUsers = useCallback(async ()     => {
    const response = await getAssignedToData();
    if (response && response.domain) {
        const options = response.domain.map((state) => (
            <option key={state.assigned_to} value={state.assigned_to}>{state.assigned_to}</option>
        ));
        setAssignedToList(options);
    }
}, []);

    useEffect(() => {

        getRenewalAdminDomain();
        fetchAssignedUsers();

    }, [getRenewalAdminDomain, fetchAssignedUsers])

    function handleClose() {
        handleClicked(false);
    }

    function handleSearchCustomer(event) {

        const search_item = event.target.value;

        console.log(search_item)
        const filteredList = initialDomainList.filter((customer) => {

            if ((customer && customer.customerDomain)) {

                return customer.customerDomain.toLowerCase().includes(search_item.toLowerCase());
            }
            else {
                return false
            }
        });
        setDomainList(filteredList);
        setSearch(search_item)

    }

    function handleSearchDateRange() {
        const startDate = start_date;
        const endDate = end_date;

        if (!startDate || !endDate) {
            alert('Please select both a start and end day.');
            return;
        }

        const startDay = parseInt(startDate, 10);
        const endDay = parseInt(endDate, 10);

        if (startDay > endDay) {
            alert('Start day cannot be greater than end day.');
            return;
        }

        const filteredList = initialDomainList.filter((customer) => {
            if (customer && customer.renewal_date) {
                // Assuming renewal_date is in 'DD-MM-YYYY' format
                const renewalDay = parseInt(customer.renewal_date.split('-')[0], 10);
                return renewalDay >= startDay && renewalDay <= endDay;
            }
            return false;
        });

        const sortedList = [...filteredList].sort((a, b) => {
            const dayA = parseInt(a.renewal_date.split('-')[0], 10);
            const dayB = parseInt(b.renewal_date.split('-')[0], 10);
            return dayA - dayB;
        });

        setDomainList(sortedList);
    }

    

const handleAssignedToChange = (renewal_id, value) => {
    setSelectedAssignedTo(prev => ({ ...prev, [renewal_id]: value }));
};

const handleUpdateAssignedTo = async (renewal_id) => {
    if (selectedAssignedTo[renewal_id]) {
        const response = await updateAssignedTo(renewal_id, selectedAssignedTo[renewal_id]);
        if (response) {
            alert('Assigned To Updated Successfully');
            getRenewalAdminDomain(); 
        }
    }
};
    function handleExport() {
        if (currentItems) {
            const array = [Object.keys(currentItems[0])].concat(currentItems);

            const csv = array.map(row => Object.values(row).toString()).join('\n');
            console.log(csv)
            const blob = new Blob([csv], { type: 'text/csv' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.setAttribute('href', url);
              a.setAttribute('download', 'data.csv');
                a.click();
        }
    }

    const days = Array.from({ length: 31 }, (_, i) => i + 1);
    const dayOptions = days.map(day => <option key={day} value={day} > {day}</option>);

    return <>
        {
            createPortal(
                <Div className="modal-backdrop">
                    <dialog {...props} style={{ zIndex: '1', width: '90%', overflow: 'scroll' }}>

                        <Div className="form-group" style={{ marginLeft: '15px' }}>
                            Domains Under {admin.admin_email}
                        </Div>
                        <Div className="toolbar-item col-sm-12 d-flex align-items-center" role="group" style={{ marginLeft: '15px', gap: '15px' }}>
                            <Div className='col-sm-3'>
                                <Input type='text' name='text' id='text' value={search} onChange={handleSearchCustomer} placeholder="Search" />
                            </Div>

                            <Div className='col-sm-2'>
                                <label>Start Day</label>
                                <Select onChange={(event) => setStartDate(event.target.value)} name='start_date' id='start_date' options={dayOptions} defaultValue="Start Day" />
                            </Div>

                            <Div className='col-sm-2'>
                                <label>End Day</label>
                                <Select onChange={(event) => setEndDate(event.target.value)} name='end_date' id='end_date' options={dayOptions} defaultValue="End Day" />
                            </Div>
                            <Div className="col-sm-2">
                                <FormButton type='button' onClick={handleSearchDateRange} style={{ margin: '2px' }}
                                    className="btn btn-primary submit-btn btn-block">Search Date</FormButton>
                            </Div>
                            <Div className="col-sm-2">
                                <FormButton type='button' onClick={handleExport} style={{ margin: '2px' }}
                                    className="btn btn-primary submit-btn btn-block">Export Data</FormButton>
                            </Div>

                        </Div>

                        <Div className='col-md-12 margin_top'>
                            {domainList ?
                                <>

                                    <Div style={{ overflow: 'scroll', maxHeight: '400px' }}>
                                        <table className="table table-responsive" border="1" style={{ overflow: 'scroll' }}>
                                            <thead>
                                                <tr>
                                                    <th>Customer Domain</th>
                                                    <th>Company Name</th>
                                                    <th>Plan</th>
                                                    <th>Status</th>
                                                    <th>License</th>
                                                    <th>Users</th>
                                                    <th>Sku Id</th>
                                                    <th>Shivaami Renewal Date</th>
                                                    <th>Zone</th>
                                                    <th>Google Renewal Date</th>
                                                    <th>Price</th>
                                                    <th>Segments</th>
                                                    <th>Update Assigned To</th>
                                                    {/* <th>Follow Up Comments</th>
                                                    <th>Highlighted Case Flag</th>
                                                    <th>Confirmation Status</th>
                                                    <th>Aggrement Status</th>
                                                    <th>Price Per User</th>
                                                    <th>Special Comment</th>
                                                    <th>Task Status</th>
                                                    <th>Renewed License</th>
                                                    <th>Extension Date</th> */}

                                                    {/* <th></th> */}
                                                </tr>
                                            </thead>
                                            <tbody id="tableBody">
                                                {currentItems.map((customer) =>
                                                    <>
                                                    {console.log(customer)}
                                                        <tr key={customer.renewal_id}>
                                                            <td>
                                                                {customer.customerDomain}
                                                            </td>
                                                            <td>{customer.company_name}</td>
                                                            <td>{customer.plan_name}</td>
                                                            <td>{customer.status}</td>
                                                            <td>{customer.licensed_seats}</td>
                                                            <td>{customer.number_of_seats}</td>
                                                            <td>{customer.sku_name}</td>
                                                            <td>{customer.renewal_date}</td>
                                                            <td>{customer.zone}</td>
                                                            <td>{customer.google_renewal_data}</td>
                                                            <td>{customer.price}</td>
                                                            <td>{customer.segments} </td>
                                                            <td>
    <Div className="d-flex flex-column gap-1">
        <Select
            options={assignedToList}
            defaultValue={customer.assigned_to || 'Unassigned'}
            onChange={(e) => handleAssignedToChange(customer.renewal_id, e.target.value)}
        />
        <FormButton 
            className="btn btn-primary btn-sm" 
            onClick={() => handleUpdateAssignedTo(customer.renewal_id)}
        >
            Update
        </FormButton>
    </Div>
</td>
                                                            {/* <td>{customer.followup_comments}</td>
                                                            <td></td>
                                                            <td>{customer.confirmation_status}</td>
                                                            <td>
                                                                {customer.agreement_status}
                                                            </td>
                                                            <td>{customer.price_per_user}</td>
                                                            <td>{customer.special_comments}</td>
                                                            <td>{customer.task_status ? customer.task_status : customer.reason}</td>
                                                            <td>{customer.renewed_lic}</td>
                                                            <td>{customer.extension_date}</td> */}


                                                        </tr>
                                                    </>

                                                )

                                                }
                                            </tbody>
                                        </table>
                                    </Div>
                                    {domainList.length > 0 ?
                                        <Stack spacing={2}>
                                            <Pagination count={totalPages} color="primary" page={currentPage} onChange={paginate}>

                                            </Pagination>

                                        </Stack> : null
                                    }
                                </>
                                : null}
                        </Div>
                        <Div className="form-group">
                            <Div className='row'>
                                <Div className='col-sm-9'>
                                    {/* <FormButton type='button' style={{margin:'2px'}} 
                                // onClick={handleAddLicense} 
                                className="btn btn-primary submit-btn btn-block">Add Domain</FormButton> */}
                                </Div>
                                <Div className='col-sm-2'>
                                    <FormButton type='button' onClick={handleClose} style={{ margin: '2px' }} className="btn btn-primary submit-btn btn-block" >Close</FormButton>
                                </Div>
                            </Div>

                                        
                            <Div className='row'>
                                <Div className='col-sm-12'>
                                    {/* {error ?  <p style={{color:'red',marginLeft: '15px', marginTop:'4px'}}> {error}</p> : null } */}
                                </Div>
                            </Div>                         
                        </Div>

                    </dialog>

                </Div>
                , document.getElementById('modal'))

        }
    </>
}